export const urlPrefixes = {
  cms999: `//cms.cekid.com/publish/999`,
  svsesapi: `//svsesapi.haiziwang.com/svses-api/api`,
  svsesapicekid: `//svsesapi.cekid.com/svses-api`,
  scbapi: `//scbapi.cekid.com/scb-api`,
  sccapi: `//sccapi.cekid.com/scc-api`,
  scouponapi: `//scouponapi.cekid.com/scoupon-api`,
  sorderapi: `//sorderapi.cekid.com`,
  addressapi: `//address.cekid.com`,
  userapi: `//user.cekid.com`,
  mallbackapi: `//mallback.cekid.com`,
  soperationapi: `//soperationapi.cekid.com`,
  soperationapikw: `//soperationapi.cekid.com`,
  svsactivityapi: `//svsactivity.cekid.com`,
  rkhyapi: `//rkhy.cekid.com`,
  czjapi: `//czjapi.cekid.com`,
  workchatapi: `//workchat.cekid.com`,
  spromotionapi: `//spromotionapi.cekid.com`,
  czjcapi: `//czjcapi.cekid.com/api-c`,
  xingbeibaoxianapi: `//finweb.xingbeibaoxian.com`,
  socialapi: `//social.cekid.com`,
  imsapi: `//ims.cekid.com`,
  miniappqrcodeapi: `//miniappqrcode.cekid.com`,
  digitalapi: `//digital.cekid.com`,
  iasapi: `//ias.cekid.com`,
  materialapi: `//material.cekid.com`,
  playapi: `//play.cekid.com`,
  adApi: `//adolapi.cekid.com` // 城市广告
}
